import { atom } from 'recoil';

export const showPrintAtom = atom({ key: 'showPrintAtom', default: false });
